module.exports = __webpack_public_path__ + "static/code-912a0937a4e00cab64e5c689cd930773.svg";